import React from "react";

const ViolationPrintContent = ({
  violationDetails,
  member,
  violationType,
  comments = [] // in case you want to extend later
}) => {
  return (
    <div className="print-container">
      <h1 className="print-title">Violation Report</h1>

      <section className="workorder-section">
        <h2>Violation #{violationDetails?.id}</h2>
        <div className="workorder-details-horizontal">
          <div><strong>Status:</strong> {violationDetails?.status || "N/A"}</div>
          <div><strong>Assigned To:</strong> {violationDetails?.resolved_by_name || "N/A"}</div>
          <div><strong>Type:</strong> {violationType || "N/A"}</div>
          <div><strong>Property:</strong> {member?.property_name || "N/A"}</div>
          <div><strong>Owner Name:</strong> {member?.first_name} {member?.last_name}</div>
          <div><strong>Created At:</strong> {new Date(violationDetails?.created_at).toLocaleString()}</div>
        </div>

        <p><strong>Description:</strong></p>
        <blockquote>{violationDetails?.description || "No description available."}</blockquote>
      </section>

      <hr className="divider" />

      <section className="comments-section">
        <h3>💬 Comments</h3>
        {violationDetails.comments?.length > 0 ? (
          violationDetails.comments.map((c) => (
            <div key={c.comment_id} className="comment-block">
              <div className="comment-header">
                <span className="comment-author"><strong>{c.user_name} {c.user_lastname}</strong></span>
                <span className="comment-date">{new Date(c.sent_at).toLocaleString()}</span>
              </div>
              <blockquote className="comment-body">{c.comment_text}</blockquote>
            </div>
          ))
        ) : (
          <p>No comments recorded.</p>
        )}
      </section>

      <hr className="divider" />

      <div className="print-footer">
        Printed on {new Date().toLocaleString()}. My HOA Management System
      </div>
    </div>
  );
};

export default ViolationPrintContent;
